import { createI18n } from 'vue-i18n';
import axios from 'axios';

const language = JSON.parse(localStorage.getItem('language')) || {
    language: 'en',
};

const loadedLanguages = [];

export const i18n = createI18n({
    locale: null,
    fallbackLocale: 'en',
    messages: {},
    silentFallbackWarn: true,
    silentTranslationWarn: true,
});

function setLocale(lang)
{
    if (i18n.mode === 'legacy')
    {
        i18n.global.locale = lang;
    }
    else
    {
        i18n.global.locale.value = lang;
    }

    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);

    return lang;
}

export async function loadLanguage(lang)
{
    if (typeof lang === 'undefined')
    {
        lang = navigator.language || navigator.userLanguage;
        lang = lang.split('-')[0];
    }

    if (i18n.global.locale !== lang && i18n.global.locale.value !== lang)
    {
        if (!loadedLanguages.includes(lang))
        {
            try
            {
                const msgs = await import(
                    /* webpackChunkName: "lang-[request]" */
                    `@/assets/lang/${lang}.json`
                );

                i18n.global.setLocaleMessage(lang, msgs);
                loadedLanguages.push(lang);

                return setLocale(lang);
            }
            catch (error)
            {
                return Promise.reject(`${lang} not loaded: ${error}`);
            }
        }

        return Promise.resolve(setLocale(lang));
    }

    return Promise.resolve(lang);
}

loadLanguage(language.language);
